import "./index.scss";
import App from "./App";
import { Suspense } from "react";
import Store from "./store/store";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import Loading from "./components/common/Loader";
import { BrowserRouter as Router } from "react-router-dom";
import SessionTimeout from "./components/SessionTimeout";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const handleLogout = async () => {
  const logOutUrl = process.env.REACT_APP_LOGOUT_URL; //Temporary fix
  localStorage.clear();
  if (logOutUrl) window.location.assign(logOutUrl);
};

root.render(
  // <React.StrictMode>
  <Provider store={Store}>
    {/* <ErrorBoundary fallback={<div>Something went wrong</div>}> */}
    <Suspense fallback={<Loading isLoading={true} />}>
      <Router>
        {localStorage.getItem("loginemail") && (
          <SessionTimeout onLogout={handleLogout} />
        )}
        <App />
      </Router>
    </Suspense>
    {/* </ErrorBoundary> */}
  </Provider>,
  // </React.StrictMode>
);

reportWebVitals(console.log);
